export class LoaderComponentConstants {
  static DEFAULT_DIAMETER = 50;
  static DEFAULT_STROKE_WIDTH = 5;
  static PERCENTAGE_TEMPLATE_VALUE = '%percentage%';
}
